"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductBuilder = void 0;
const React = require("react");
const react_1 = require("react");
const Mustache = require("mustache");
const cloneModelObject_1 = require("../../../../../apis/spg/util/cloneModelObject");
const GroupHeading_1 = require("../../../../../components/base/atoms/GroupHeading");
const BlueprintStockedProductCard_1 = require("../BlueprintStockedProductCard");
const AddExtrasButtons_1 = require("./AddExtrasButtons");
const Block_1 = require("../../../../../components/base/structure/Block");
const DoubleSelectionButtons_1 = require("./DoubleSelectionButtons");
const useRemoveAllSelectionsInCategory_1 = require("../../hooks/useRemoveAllSelectionsInCategory");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "ProductBuilder");
/**
 * User interface where one can customise a blueprint product
 * and add the finalised build to his sales order.
 */
const ProductBuilder = ({ salesOrderItem, onChange }) => {
    const [item, setItem] = (0, react_1.useState)(salesOrderItem);
    const { productBlueprint } = item;
    const { categories, requiredCategoriesMap } = productBlueprint;
    // function to add or increase quantity of an ingredient to a built product
    const addProduct = (blueprintStockedProduct) => {
        item.addProduct(blueprintStockedProduct);
        const newItem = (0, cloneModelObject_1.cloneModelObject)(item);
        setItem(newItem);
        onChange && onChange();
    };
    // function to add or remove quantity of an ingredient to a built product
    // if the all flag is set it will completely remove the ingredient from selection otherwise it will just remove one
    const removeProducts = (blueprintStockedProducts, all = false) => {
        blueprintStockedProducts.forEach(blueprintStockedProducts => {
            salesOrderItem.removeProduct(blueprintStockedProducts, all);
        });
        const newItem = (0, cloneModelObject_1.cloneModelObject)(item);
        setItem(newItem);
        onChange && onChange();
    };
    return (React.createElement("div", { className: css("") }, categories.map((category, index) => {
        // build out each category content
        const { name: categoryName } = category;
        const { mainProductSelections, alwaysExtraSelections } = productBlueprint.getCategoryProductSelections(categoryName);
        const hasMainProductSelections = productBlueprint.hasMainProductSelections(categoryName);
        return (React.createElement("div", { 
            // ref={value === index ? itemRef : null}
            key: index, className: css("category"), id: category.name },
            React.createElement(GroupHeading_1.GroupHeading, null,
                category.label,
                requiredCategoriesMap.get(category.name) && (React.createElement("div", { className: css("requiredText") }, "(Required)"))),
            React.createElement(CategoryDescription, { category: category }),
            hasMainProductSelections && (React.createElement(CategoryContent, { salesOrderItemBuilt: salesOrderItem, categoryBlueprintStockedProducts: mainProductSelections, category: category, addProduct: addProduct, removeProducts: removeProducts })),
            alwaysExtraSelections.length > 0 && (React.createElement(React.Fragment, null,
                mainProductSelections.length > 0 && (React.createElement(Block_1.Block, null,
                    React.createElement(Block_1.BlockHeader, null,
                        React.createElement(Block_1.BlockTitle, null, "something extra?")))),
                React.createElement(CategoryContent, { salesOrderItemBuilt: salesOrderItem, categoryBlueprintStockedProducts: alwaysExtraSelections, category: category, addProduct: addProduct, removeProducts: removeProducts })))));
    })));
};
exports.ProductBuilder = ProductBuilder;
/**
 * Show a description for a category of ingredients in a product blueprint.
 * The category description comes from the CMS and can render template data
 * within the object like category price for extras
 */
const CategoryDescription = ({ category }) => (React.createElement("div", { className: css("categoryDescription") }, category.description && Mustache.render(category.description, category)));
/**
 * Show ingredient selections as well as add extra/double ingredient buttons if turned on for the given category
 */
const CategoryContent = ({ salesOrderItemBuilt, categoryBlueprintStockedProducts, category, addProduct, removeProducts }) => {
    const { hasAddButtons, hasDoubleSelectionButtons } = category;
    return (React.createElement(React.Fragment, null,
        React.createElement(CategoryProducts, { salesOrderItemBuilt: salesOrderItemBuilt, categoryBlueprintStockedProducts: categoryBlueprintStockedProducts, category: category, addProduct: addProduct, removeProducts: removeProducts }),
        hasAddButtons && (React.createElement(AddExtrasButtons_1.AddExtraButtons, { salesOrderItemBuilt: salesOrderItemBuilt, categoryBlueprintStockedProducts: categoryBlueprintStockedProducts, category: category, addProduct: addProduct, removeProducts: removeProducts })),
        hasDoubleSelectionButtons && (React.createElement(DoubleSelectionButtons_1.DoubleSelectionButtons, { salesOrderItemBuilt: salesOrderItemBuilt, categoryBlueprintStockedProducts: categoryBlueprintStockedProducts, category: category, addProduct: addProduct, removeProducts: removeProducts }))));
};
/**
 * All ingredient selection panels in the given category
 */
const CategoryProducts = ({ salesOrderItemBuilt, categoryBlueprintStockedProducts, category, addProduct, removeProducts }) => {
    const removeAllSelections = (0, useRemoveAllSelectionsInCategory_1.useRemoveAllSelectionsInCategory)(salesOrderItemBuilt, category.name, removeProducts);
    return (React.createElement(React.Fragment, null, categoryBlueprintStockedProducts.map((blueprintStockedProduct, index) => (React.createElement(BlueprintStockedProductCard_1.BlueprintStockedProductCard, { key: index, salesOrderItemBuilt: salesOrderItemBuilt, blueprintStockedProduct: blueprintStockedProduct, onAddClick: () => addProduct(blueprintStockedProduct), onRemoveClick: () => removeProducts([blueprintStockedProduct]), removeAllSelections: removeAllSelections })))));
};
//# sourceMappingURL=index.js.map